var _circle, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#338af3",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m400.696 258.783h-289.392c0 19.979 17.401 36.174 37.378 36.174h-1.204c0 19.979 16.195 36.174 36.174 36.174 0 19.979 16.195 36.174 36.174 36.174h72.348c19.979 0 36.174-16.195 36.174-36.174 19.979 0 36.174-16.195 36.174-36.174h-1.204c19.975 0 37.378-16.195 37.378-36.174z",
    fill: "#ffda44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m356.174 211.478c0 55.324-44.85 100.174-100.174 100.174-55.325 0-100.174-44.85-100.174-100.174",
    fill: "#338af3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m332.515 211.478-31.265 14.707 16.649 30.28-33.95-6.495-4.302 34.296-23.647-25.225-23.648 25.225-4.301-34.296-33.95 6.493 16.648-30.279-31.264-14.706 31.265-14.706-16.649-30.279 33.949 6.494 4.303-34.296 23.647 25.225 23.648-25.225 4.301 34.296 33.951-6.494-16.649 30.28z",
    fill: "#ffda44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKz);
export default __webpack_public_path__ + "static/media/4bd96339573067c8c77dcf4bc88112aacc3ecd318c.svg";
export { ForwardRef as ReactComponent };